export const environment = {
    production: false,
    //baseUrl : 'http://localhost:3000',
    baseUrl : 'https://dev.gutouch.net/bulkapisec/touchCash',
    urlLogin : 'https://dev.gutouch.net/bulkapisec/access_token/get_access_token',
    urlTicket : "https://dev.gutouch.net/bulkapisec/collecte",

    keycloak:{
        url : "https://intouchgu2-qlf.worldline-solutions.com/auth",
        realm : "sso-intouch-iacc",
        clientId : "front-collecte"
    },
    collecteKVAR : "FkQ6UeMHEsKAP8ZWfXmB7D2xbtwG5q"
};